import { render } from "./CreateUserPage.vue?vue&type=template&id=05aad272&scoped=true&ts=true"
import script from "./CreateUserPage.vue?vue&type=script&lang=ts"
export * from "./CreateUserPage.vue?vue&type=script&lang=ts"

import "./CreateUserPage.vue?vue&type=style&index=0&id=05aad272&scoped=true&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05aad272"]])

export default __exports__